var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03167 10.533C1.15058 11.4908 1.92435 12.2474 2.88428 12.3478C4.21258 12.4866 5.58924 12.6333 7 12.6333C8.41076 12.6333 9.78742 12.4866 11.1157 12.3478C12.0756 12.2474 12.8494 11.4908 12.9683 10.533C13.1103 9.38946 13.25 8.20685 13.25 6.99631C13.25 5.78578 13.1103 4.60317 12.9683 3.45963C12.8494 2.50183 12.0756 1.74518 11.1157 1.64484C9.78742 1.50599 8.41076 1.35938 7 1.35938C5.58924 1.35938 4.21257 1.50599 2.88428 1.64484C1.92435 1.74518 1.15058 2.50183 1.03166 3.45963C0.88969 4.60317 0.75 5.78578 0.75 6.99631C0.75 8.20685 0.88969 9.38946 1.03167 10.533Z",
    fill: "white",
    stroke: "#0C0C0C",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0625 3.20312L5.76461 6.91059C6.49086 7.48321 7.515 7.48321 8.24124 6.91059L12.9434 3.20312",
    stroke: "#0C0C0C",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.204e23b7327fa043e9db8263e3de5397.svg";
export { ForwardRef as ReactComponent };